// ────────────────────────────────────────────────────────────────
// Carte de découvrabilité — Stripe Connect & SUPER PDP
// Pure suggestion non bloquante : ces deux fonctionnalités existent déjà
// et fonctionnent (niveau 2 : le tenant facture ses propres clients ;
// facturation électronique conforme réforme 2026). Rien n'est ajouté ici
// comme étape obligatoire de l'onboarding — juste un rappel dismissible.
// ────────────────────────────────────────────────────────────────
import { useEffect, useState } from "react";
import { CreditCard, FileCheck2, X } from "lucide-react";
import api, { getToken } from "../services/api";

const STORAGE_KEY = "growth_discovery_v1_dismissed";

export default function GrowthDiscoveryCard({ currentCompanyId, onNavigate }) {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "true"
  );
  const [stripeConnected, setStripeConnected] = useState(true); // true par défaut = pas de suggestion tant que l'appel n'a pas répondu
  const [pdpConnected, setPdpConnected]       = useState(true);

  useEffect(() => {
    if (!currentCompanyId || dismissed) return;
    api.stripeConnect.status(currentCompanyId)
      .then(s => setStripeConnected(!!s?.connected))
      .catch(() => {});

    (async () => {
      try {
        const token = await getToken();
        const resp = await fetch('/api/factelec/status?company_id=' + currentCompanyId, {
          headers: { Authorization: 'Bearer ' + token },
        });
        const data = await resp.json();
        if (resp.ok) setPdpConnected(!!data?.connected);
      } catch {}
    })();
  }, [currentCompanyId, dismissed]);

  const dismiss = () => { localStorage.setItem(STORAGE_KEY, "true"); setDismissed(true); };

  if (dismissed || (stripeConnected && pdpConnected)) return null;

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 14,
      background: "var(--bg-card)", border: "var(--border)", borderRadius: 12,
      padding: "14px 18px", marginBottom: 18,
    }}>
      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
        {!stripeConnected && <CreditCard size={18} color="var(--accent)" />}
        {!pdpConnected && <FileCheck2 size={18} color="var(--accent)" />}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-primary)" }}>
          Allez plus loin avec ExecPro360
        </div>
        <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>
          {!stripeConnected && "Connectez Stripe Connect pour encaisser vos propres clients directement. "}
          {!pdpConnected && "Activez SUPER PDP pour votre facturation électronique conforme 2026."}
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
        {!stripeConnected && (
          <button
            onClick={() => onNavigate?.('abonnements')}
            style={{ fontSize: 12, fontWeight: 600, color: "var(--accent)", background: "none", border: "1px solid var(--accent)", borderRadius: 6, padding: "6px 12px", cursor: "pointer" }}
          >
            Stripe Connect
          </button>
        )}
        {!pdpConnected && (
          <button
            onClick={() => onNavigate?.('factelec')}
            style={{ fontSize: 12, fontWeight: 600, color: "var(--accent)", background: "none", border: "1px solid var(--accent)", borderRadius: 6, padding: "6px 12px", cursor: "pointer" }}
          >
            SUPER PDP
          </button>
        )}
        <button
          onClick={dismiss}
          aria-label="Fermer"
          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)", padding: 4 }}
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
